import axios from "axios";
import { router } from "../_helpers";

axios.defaults.withCredentials = true;

axios.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

axios.interceptors.response.use(
  response => {
    NProgress.done();
    return response;
  },
  () => {
    NProgress.done();
    router.push("/login");
    return null;
  }
);

export default axios;
